<template>
  <div class="MoreMovie" style="margin-top: 100px">
    <!-- Container -->
    <div class="container" v-loading="mloading" element-loading-background="transparent">
      <!-- 影片一覽 -->
      <section id="all-video" class="section-group">
        <N3Vue></N3Vue>
        <h2 class="section-title">{{ $t('Video.MoreMovie.MovieList') }}</h2>
        <div class="section-sub">
          <div class="category">
            <el-button size="mini" :class="{ current: -1 == currenTypeId }" @click="GetListByType(-1)">{{ $t('Video.MoreMovie.All') }}</el-button>
            <el-button size="mini" v-for="item in MovieTypeList" :key="item.id"
              :class="{ current: item.id == currenTypeId }" @click="GetListByType(item.id)">{{ item.sgL_Type_Name
              }}</el-button>
          </div>
          <div class="sorting right">
            {{ $t('Video.MoreMovie.order') }}&nbsp;
            <el-button size="mini" @click="orderbyhot('CreateTime')"
              :class="{ current: 'CreateTime' == selectoption }">{{ $t('Video.MoreMovie.Press') }}</el-button>
            <el-button size="mini" @click="orderbyhot('QueriesCount')"
              :class="{ current: 'QueriesCount' == selectoption }">{{ $t('Video.MoreMovie.popularity') }}</el-button>
            <!-- <a id="sorting-latest" class="current">
              <span>按最後更新</span>
            </a>
            <a id="sorting-hottest">
              <span>按熱門程度</span>
            </a>-->
          </div>
        </div>
        <div class="video-row row">
          <div class="video-card card mb-4" v-for="movie in getList" v-bind:key="movie.id">
            <router-link v-bind:to="{
              name: 'WatchVideo',
              params: { id: movie.id, itemtype: 'video' },
            }">
              <div class="video-block">
                <div class="video-thumbnail">
                  <div class="video-responsive">
                    <div class="video-sizer">
                      <div class="video-image" :style="{
                        backgroundImage: 'url(' + `${movie.imageFileP}` + '),url(' + `${require('../../assets/images/404.png')}` + ')',
                      }"></div>
                    </div>
                  </div>
                  <div class="video-duration">
                    <span>{{ movie.mov_VSourceTimeFormat }}</span>
                  </div>
                </div>
              </div>
              <div class="video-info p-3">
                <div class="video-title mb-2">{{ movie.sgL_Mov_VSubject }}</div>
                <span class="video-user">
                  <a href="javascript:;">{{ movie.sgL_Mem_DisplayName }}</a>
                </span>
                <span class="video-upload-date">{{
                  movie.sgL_Mov_VAddTimerH
                }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </section>
    </div>
    <!-- /.Container -->
  </div>
</template>

<script>
import N3Vue from "../Ad/N3.vue";
import { mapState, mapGetters, mapMutations, mapAction } from "vuex";
let currentPage = 2;
let limit = 8;
export default {
  components: {
    N3Vue,
  },
  name: "MoreMovie",
  data() {
    return {
      currenTypeId: -1,
      moiveTypeList: [],
      msg: "",
      mloading: true,
      selectoption: "CreateTime",
      moiveList: [],
    };
  },
  watch: {
    // moiveList(newvalue, oldvalue) {
    //   if (newvalue.length > 0) {
    //     this.mloading = false;
    //   } else {
    //     this.mloading = true;
    //   }
    // }
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 1);
    this.GetMovieList();
    // this.GetMovieTypeList();
  },
  mounted() {
    this.scroll();
  },
  methods: {
    async GetMovieList() {
      //重新加载视频重置分页
      currentPage = 2;
      let param = {
        SkipCount: 0,
        MaxResultCount: 8,
        SGL_Moive_TypeId: this.currenTypeId,
        Sorting: this.selectoption,
      };
      this.$api.VideoApi.VideoListDesk(param).then((result) => {
        this.mloading = false;
        //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
        this.moiveList = result.data.result.items;
      });
    },
    async GetMovieTypeList() {
      let param = { SkipCount: 0, MaxResultCount: 50 };
      this.$api.VideoApi.GetMovieTypeList(param).then((result) => {
        //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>+
        this.moiveTypeList = result.data.result.items;
      });
    },
    GetListByType(Id) {
      this.currenTypeId = Id;
      this.GetMovieList();
      // if (Id == 0) {
      //   this.GetMovieList();
      // } else {
      //   let params = {
      //     SGL_Moive_TypeId: Id,
      //     Sorting: "1",
      //     SkipCount: 0,
      //     MaxResultCount: 50
      //   };
      //   this.$api.VideoApi.GetMovieTypeListById(params).then(result => {
      //     this.mloading = false;
      //     this.moiveList = result.data.result.items;
      //   });
      // }
    },
    async orderbyhot(current) {
      this.selectoption = current;
      this.GetMovieList();
      let param = { SkipCount: 0, MaxResultCount: 50, Sorting: "QueriesCount" };
      // this.$api.VideoApi.VideoListDesk(param).then(result => {
      //   this.mloading = false;
      //   //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
      //   this.moiveList = result.data.result.items;
      // });
    },
    scroll() {
      let isLoading = false;
      window.onscroll = () => {
        // 距离底部200px时加载一次
        let bottomOfWindow =
          document.documentElement.offsetHeight -
          document.documentElement.scrollTop -
          window.innerHeight <=
          300;
        if (bottomOfWindow && isLoading == false) {
          isLoading = true;
          let param = {
            SkipCount: (currentPage - 1) * limit,
            MaxResultCount: limit,
          };
          this.$api.VideoApi.VideoListDesk(param).then((result) => {
            result.data.result.items.map((item, index) => {
              this.moiveList.push(item);
            });
            currentPage++;
            isLoading = false;
          });
        }
      };
    },
  },
  computed: {
    getList() {
      return this.moiveList;
    },
    // MovieTypeList() {
    //   return this.moiveTypeList;
    // },
    ...mapGetters({ MovieTypeList: "getVideoCategorygetters" }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Video/MoreMovie.vue